import React from "react";

import { Button, Col, Divider, Form, Input, Row } from "antd";

const SellerSearch = ({
  searchOption,
  setSearchOption,
  targetYear,
  targetMonth,
  getCommissionData,
  pageSize,
  setPageSize,
  offset,
  setOffset,
  currentPageNumber,
  setCurrentPageNumber,
}) => {
  /**
   * 검색
   */
  const handleSearch = () => {
    if (pageSize !== 10) {
      setPageSize(10);
    }
    if (offset !== 0) {
      setOffset(0);
    }
    if (currentPageNumber !== 1) {
      setCurrentPageNumber(1);
    }
    getCommissionData(targetYear, targetMonth, "search");
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    if (pageSize !== 10) {
      setPageSize(10);
    }
    if (offset !== 0) {
      setOffset(0);
    }
    if (currentPageNumber !== 1) {
      setCurrentPageNumber(1);
    }
    setSearchOption({ name: null });
    getCommissionData(targetYear, targetMonth, "reset");
  };

  return (
    <div className="product-search-box-wrap">
      <Form.Item
        className="center-label"
        label="상세검색"
        labelAlign="left"
        colon={false}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 21 }}
      >
        <Row align="middle">
          <Col sm={5} md={2}>
            <div className="content-search-wrap">이름</div>
          </Col>
          <Col style={{ marginRight: "2rem" }}>
            <Input
              name="name"
              value={searchOption.name}
              onChange={(e) =>
                setSearchOption({
                  ...searchOption,
                  [e.target.name]: e.target.value,
                })
              }
              style={{ width: 150, textAlign: "left" }}
              onPressEnter={handleSearch}
            />
          </Col>
          {/*<Col sm={5} md={2}>*/}
          {/*	<div className="content-search-wrap">연락처</div>*/}
          {/*</Col>*/}
          {/*<Col>*/}
          {/*	<Input*/}
          {/*		name="phone"*/}
          {/*		// value={searchOptions.phone}*/}
          {/*		// onChange={(e) =>*/}
          {/*		// 	setSearchOptions({*/}
          {/*		// 		...searchOptions,*/}
          {/*		// 		[e.target.name]: e.target.value,*/}
          {/*		// 	})*/}
          {/*		// }*/}
          {/*		style={{ width: 200, textAlign: "left" }}*/}
          {/*		// onPressEnter={handleSearch}*/}
          {/*	/>*/}
          {/*</Col>*/}
        </Row>
      </Form.Item>
      <Divider className="product-register-form-input-divider" />
      <Row className="product-search-button-wrap" justify="center">
        <Button className="product-search-button search" onClick={handleSearch}>
          검색
        </Button>
        <Button
          className="product-search-button initial"
          onClick={handleInitialBtnClick}
        >
          초기화
        </Button>
      </Row>
    </div>
  );
};

export default SellerSearch;
